import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import BaseTextarea from "../BaseControls/Textarea";
import {controlPropTypes} from "../formhelpers";

export default class Textarea extends React.Component {
    render() {
        return (
            <ControlTemplate {...this.props} className="string-field textarea" >
                <BaseTextarea
                    {...this.props}
                />
            </ControlTemplate>
        );
    }
}

Textarea.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/StringField/textarea.js